
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-chatbot-development-services",
      function () {
        return require("private-next-pages/ai-chatbot-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-chatbot-development-services"])
      });
    }
  